export default function cd (context, args, flags) {
  if (args.length === 0) return 'takes one argument [directory]'

  const folder = context.getWD()
  const target = args[0]

  if (target === '../') {
    let dir = context.dir.split('/')
    console.log(dir)
    if (dir.length <= 2) return ''
    dir.pop()
    dir.pop()
    context.dir = dir.join('/') + '/'
    return ''
  } else if (folder[target] === undefined || folder[target].type !== 'folder') {
    return `no directory ${target}`
  } else {
    context.dir += target + '/'
    return ''
  }
}



// WEBPACK FOOTER //
// ./src/natos/commands/cd.js